import * as React from 'react';



export default class Filter extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="icon" transform="translate(2.000000, 3.000000)"><g id="Group-25"><circle id="Oval" className="st0" cx="6.5" cy="1.1" r="1.1"></circle><path id="Path-6" className="st1" d="M8.1,1.1H12"></path><path id="Path-6-Copy" className="st1" d="M0,1.1c3.3,0,4.9,0,4.9,0"></path></g><g id="Group-24" transform="translate(0.000000, 4.363636)"><circle id="Oval-Copy-3" className="st0" cx="3.3" cy="1.1" r="1.1"></circle><path id="Path-6-Copy-3" className="st1" d="M4.9,1.1H12"></path><path id="Path-6-Copy-2" className="st1" d="M0,1.1h2.2"></path></g><g id="Group-23" transform="translate(0.000000, 7.636364)"><circle id="Oval-Copy-4" className="st0" cx="6.5" cy="2.2" r="1.1"></circle><path id="Path-6-Copy-5" className="st1" d="M8.1,2.2H12"></path><path id="Path-6-Copy-4" className="st1" d="M0,2.2c0,0,1.6,0,4.9,0"></path></g></g>
      </svg>
    )
  }
}
